import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nav nav-tabs",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  class: "nav-link active",
  id: "nav-home-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#nav-home",
  type: "button",
  role: "tab",
  "aria-controls": "nav-home",
  "aria-selected": "true"
}, "Detalle", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "nav-link",
  id: "nav-profile-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#nav-profile",
  type: "button",
  role: "tab",
  "aria-controls": "nav-profile",
  "aria-selected": "false"
}, "Incidencias", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_7 = {
  class: "tab-pane fade show active",
  id: "nav-home",
  role: "tabpanel",
  "aria-labelledby": "nav-home-tab",
  tabindex: "0"
}
const _hoisted_8 = { class: "d-flex flex-center flex-column" }
const _hoisted_9 = { class: "symbol symbol-100px symbol-circle mb-7" }
const _hoisted_10 = { class: "fs-3 text-gray-800 fw-bold" }
const _hoisted_11 = { class: "fs-3 text-gray-800 fw-bold mb-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-4 text-primary" }, "Información personal", -1)
const _hoisted_14 = {
  key: 0,
  class: "d-flex flex-column mb-4"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Documento: ", -1)
const _hoisted_17 = { class: "text-gray-700 m-0" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "F. Nacimiento: ", -1)
const _hoisted_20 = { class: "text-gray-700 m-0" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Sexo: ", -1)
const _hoisted_23 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_24 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Dirección: ", -1)
const _hoisted_27 = { class: "text-gray-700 m-0" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Email: ", -1)
const _hoisted_30 = { class: "text-gray-700 m-0" }
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Celular: ", -1)
const _hoisted_33 = { class: "text-gray-700 m-0" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-4 text-primary" }, "Información académica", -1)
const _hoisted_37 = {
  key: 1,
  class: "d-flex flex-column mb-4"
}
const _hoisted_38 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Formación: ", -1)
const _hoisted_40 = { class: "text-gray-700 m-0" }
const _hoisted_41 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Condición: ", -1)
const _hoisted_43 = { class: "text-gray-700 m-0" }
const _hoisted_44 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Periodo: ", -1)
const _hoisted_46 = { class: "text-gray-700 m-0" }
const _hoisted_47 = {
  key: 3,
  class: "d-flex align-items-center"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Ciclo: ", -1)
const _hoisted_49 = { class: "text-gray-700 m-0" }
const _hoisted_50 = { class: "d-flex align-items-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Código alumno: ", -1)
const _hoisted_52 = { class: "text-gray-700 m-0" }
const _hoisted_53 = {
  key: 4,
  class: "d-flex align-items-center"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Tipo matrícula: ", -1)
const _hoisted_55 = { class: "text-gray-700 m-0" }
const _hoisted_56 = { class: "d-flex align-items-center" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "N# créditos: ", -1)
const _hoisted_58 = { class: "text-gray-700 m-0" }
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Facultad: ", -1)
const _hoisted_61 = { class: "text-gray-700 m-0" }
const _hoisted_62 = { class: "d-flex align-items-center" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Especialidad: ", -1)
const _hoisted_64 = { class: "text-gray-700 m-0" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Peso: ", -1)
const _hoisted_67 = { class: "text-gray-700 m-0" }
const _hoisted_68 = { class: "d-flex align-items-center" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-150px" }, "Talla: ", -1)
const _hoisted_70 = { class: "text-gray-700 m-0" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-4 text-primary" }, "Detalle de participación", -1)
const _hoisted_73 = {
  key: 2,
  class: "d-flex flex-column mb-4"
}
const _hoisted_74 = { class: "d-flex align-items-center" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Evento: ", -1)
const _hoisted_76 = { class: "text-gray-700 m-0" }
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Deporte: ", -1)
const _hoisted_79 = { class: "text-gray-700 m-0" }
const _hoisted_80 = { class: "d-flex align-items-center" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Función: ", -1)
const _hoisted_82 = { class: "text-gray-700 m-0" }
const _hoisted_83 = { class: "d-flex align-items-center" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Institución: ", -1)
const _hoisted_85 = { class: "text-gray-700 m-0" }
const _hoisted_86 = { class: "d-flex align-items-center" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Registrado: ", -1)
const _hoisted_88 = { class: "text-gray-700 m-0" }
const _hoisted_89 = { class: "d-flex align-items-center" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 w-md-100px" }, "Estado: ", -1)
const _hoisted_91 = {
  key: 3,
  class: "d-flex flex-column"
}
const _hoisted_92 = { class: "fw-bolder text-info" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_94 = { class: "fs-7" }
const _hoisted_95 = {
  key: 0,
  class: "badge badge-info"
}
const _hoisted_96 = {
  key: 1,
  class: "badge badge-info"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-4 text-primary" }, "Documentación", -1)
const _hoisted_99 = {
  key: 4,
  class: "d-flex flex-column"
}
const _hoisted_100 = { class: "fw-bolder" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_102 = { class: "fs-7" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm bg-white border border-warning text-hover-warning" }, "Descargar", -1)
const _hoisted_104 = {
  key: 5,
  class: "alert alert-warning d-flex align-items-center",
  role: "alert"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle text-dark fs-4 me-2" }, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", null, " No se encontró documentación alguna. ", -1)
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = {
  class: "tab-pane fade",
  id: "nav-profile",
  role: "tabpanel",
  "aria-labelledby": "nav-profile-tab",
  tabindex: "0"
}
const _hoisted_109 = {
  key: 0,
  class: "timeline"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px border-primary" }, null, -1)
const _hoisted_111 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_112 = { class: "symbol-label bg-light-primary border border-primary" }
const _hoisted_113 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_114 = { class: "timeline-content mb-10 mt-n1 bg-light px-4 py-2 border border-secondary rounded" }
const _hoisted_115 = { class: "mb-5 pe-3" }
const _hoisted_116 = ["innerHTML"]
const _hoisted_117 = { class: "d-flex align-items-center mt-1 fs-6" }
const _hoisted_118 = { class: "text-gray-800 me-2 fs-7" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill" }, null, -1)
const _hoisted_120 = {
  key: 1,
  class: "alert alert-warning d-flex align-items-center",
  role: "alert"
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle text-dark fs-4 me-2" }, null, -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", null, " No se encontró incidencia alguna. ", -1)
const _hoisted_123 = [
  _hoisted_121,
  _hoisted_122
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.gblDrawer1,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gblDrawer1) = $event)),
    direction: "rtl",
    size: "450",
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed
  }, {
    header: _withCtx(() => [
      _createElementVNode("nav", null, [
        (_ctx.prt.person)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.prt.person)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_avatar, {
                      shape: "circle",
                      size: "large",
                      class: _normalizeClass(`border border-3 shadow`),
                      style: {"width":"110px","height":"110px"},
                      fit: "fit",
                      src: `${_ctx.url}/uploads/${_ctx.prt.photo?.ruta}`
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.prt?.person.firstname), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.prt?.person.lastname) + " " + _toDisplayString(_ctx.prt?.person.surname), 1)
                ]),
                _hoisted_12,
                _hoisted_13,
                (_ctx.prt?.person)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("h6", _hoisted_17, _toDisplayString(_ctx.prt.person.docname) + " " + _toDisplayString(_ctx.prt.person.docnumber), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("h6", _hoisted_20, _toDisplayString(_ctx.prt.person.birthday), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        (_ctx.prt.person.gender == 'M')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Masculino"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, "Femenino"))
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("h6", _hoisted_27, _toDisplayString(_ctx.prt.person.address), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("h6", _hoisted_30, _toDisplayString(_ctx.prt.person.email1), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("h6", _hoisted_33, [
                          _createTextVNode(_toDisplayString(_ctx.prt.person.phone1) + " ", 1),
                          (_ctx.prt.person.phone2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, "/ " + _toDisplayString(_ctx.prt.person.phone2), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_35,
                _hoisted_36,
                (_ctx.prt?.info)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (_ctx.prt.info?.straining)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("h6", _hoisted_40, _toDisplayString(_ctx.training[_ctx.prt.info.straining].name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.prt.info?.acondition)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("h6", _hoisted_43, _toDisplayString(_ctx.condition[_ctx.prt.info.acondition].name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.prt.info.acondition == 'E')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _hoisted_45,
                            _createElementVNode("h6", _hoisted_46, _toDisplayString(_ctx.prt.info.periodo), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.prt.info.acondition == 'P')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("h6", _hoisted_49, _toDisplayString(_ctx.prt.info.cycle), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("h6", _hoisted_52, _toDisplayString(_ctx.prt.info.studentcode), 1)
                      ]),
                      (_ctx.prt.info?.tmatricule)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("h6", _hoisted_55, _toDisplayString(_ctx.matricule[_ctx.prt.info.tmatricule].name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("h6", _hoisted_58, _toDisplayString(_ctx.prt.info.credits), 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("h6", _hoisted_61, _toDisplayString(_ctx.prt.info.faculty), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _createElementVNode("h6", _hoisted_64, _toDisplayString(_ctx.prt.info.specialty), 1)
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createElementVNode("h6", _hoisted_67, _toDisplayString(_ctx.prt.info.peso) + " Kg", 1)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("h6", _hoisted_70, _toDisplayString(_ctx.prt.info.talla) + " cm", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_71,
                _hoisted_72,
                (_ctx.prt?.info)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("h6", _hoisted_76, _toDisplayString(_ctx.prt.info.event_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createElementVNode("h6", _hoisted_79, _toDisplayString(_ctx.prt.info.sport_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _createElementVNode("h6", _hoisted_82, _toDisplayString(_ctx.prt.info.function_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createElementVNode("h6", _hoisted_85, _toDisplayString(_ctx.prt.info.institution), 1)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _createElementVNode("h6", _hoisted_88, _toDisplayString(_ctx.prt.info.created_at), 1)
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _hoisted_90,
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge badge-${_ctx.prt.info.checkClass}`)
                        }, _toDisplayString(_ctx.prt.info.checkstatus), 3)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.prt?.test.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prt.test, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "d-flex justify-content-between shadow-sm p-4 rounded mb-5 bg-light-info align-items-center border border-info"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_92, _toDisplayString(item.cmp) + "(" + _toDisplayString(item.idniv) + ")", 1),
                            _hoisted_93,
                            _createElementVNode("span", _hoisted_94, _toDisplayString(item.test), 1)
                          ]),
                          (item.merito == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_95, "Participó"))
                            : _createCommentVNode("", true),
                          (item.merito > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(item.merito) + "° lugar", 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_97,
                _hoisted_98,
                (_ctx.prt?.files.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prt.files, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "item d-flex justify-content-between shadow-sm p-4 rounded mb-5 bg-light-warning align-items-center"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_100, _toDisplayString(item.name) + "(" + _toDisplayString(item.alias) + ")", 1),
                            _hoisted_101,
                            _createElementVNode("span", _hoisted_102, _toDisplayString(item.created_at), 1)
                          ]),
                          _hoisted_103
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_107))
              ]),
              _createElementVNode("div", _hoisted_108, [
                (_ctx.prt.auditory.length>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prt.auditory, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "timeline-item",
                          key: 'lst-h-' + index
                        }, [
                          _hoisted_110,
                          _createElementVNode("div", _hoisted_111, [
                            _createElementVNode("div", _hoisted_112, [
                              _createElementVNode("span", _hoisted_113, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com003.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("div", _hoisted_115, [
                              _createElementVNode("p", {
                                class: "fs-6 fw-bold text-gray-700 text-hover-primary mb-2",
                                innerHTML: item.message
                              }, null, 8, _hoisted_116),
                              _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("div", _hoisted_118, _toDisplayString(item.created_at), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(`badge badge-light-${_ctx.status[item.accion].name} border border-${_ctx.status[item.accion].name} me-2`)
                                }, _toDisplayString(item.accion), 3),
                                _createElementVNode("span", null, [
                                  _hoisted_119,
                                  _createTextVNode(" " + _toDisplayString(item.username), 1)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_120, _hoisted_123))
              ])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loader]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpened", "onClosed"]))
}